// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-8ad5c7b6].v-card{border-radius:6px;border-width:0}[data-v-8ad5c7b6].v-card__title{color:#055289;font-size:18px;font-weight:bold;letter-spacing:.51px;line-height:22px;justify-content:space-between}[data-v-8ad5c7b6].v-card__text{padding:0}.v-card+.v-card[data-v-8ad5c7b6]{margin-top:1ch}", ""]);
// Exports
module.exports = exports;
